<template>
  <div class="stack-page f-c">
    <div class="shortcuts global-margin f-r">
      <el-button
        type="primary"
        v-for="(row, index) in rows"
        :key="'row-' + index"
        @click="select(row)"
        :class="{ 'selected-row': selected === row }"
        class="feature-button"
      >
        {{ row }}
      </el-button>
      <el-button
        type="warning"
        @click="select('Grounds')"
        :class="{ 'selected-ground': selected === 'Grounds' }"
        class="feature-button deep-yellow-bg"
      >
        Grounds
      </el-button>
      <el-button
        type="warning"
        @click="select('Docks')"
        :class="{ 'selected-ground': selected === 'Docks' }"
        class="feature-button deep-yellow-bg"
      >
        Docks
      </el-button>
      <el-button
        type="warning"
        @click="select('TStages')"
        :class="{ 'selected-ground': selected === 'TStages' }"
        class="feature-button deep-yellow-bg"
      >
        Stages
      </el-button>
    </div>
    <div
      class="list global-margin f-c"
      v-if="selectedType === TypeStack"
      v-loading="loadingData"
    >
      <div
        class="stack-group"
        :title="group.no"
        v-for="group in stackGroups"
        :key="group.no"
      >
        <div class="f-r stack-sections">
          <div class="title cube">
            {{ group.no }}
          </div>
          <el-button
            type="primary"
            class="cube"
            v-for="stack in group.stacks"
            :key="stack.no"
            @click="selectStack(group, stack)"
            :class="{ 'selected-cube': selectedStack.no === stack.no }"
          >
            {{ stack.no.slice(3) }}
          </el-button>
        </div>
        <el-collapse-transition>
          <stack-collapse-transition
            :selected-stack="selectedStack"
            v-if="selectedGroup === group.no && selectedStack"
          ></stack-collapse-transition>
        </el-collapse-transition>
      </div>
    </div>
    <div class="grounds-info global-margin f-c" v-else v-loading="loading">
      <div class="grounds">
        <el-button
          type="primary"
          class="cube ground"
          :title="group.no"
          v-for="group in stackGroups"
          :key="group.no"
          @click="selectStack(group, group.stacks[0])"
          :class="{ 'selected-cube': selectedStack.no === group.no }"
        >
          {{ group.no }}
        </el-button>
      </div>
      <el-collapse-transition>
        <stack-collapse-transition
          :selected-stack="selectedStack"
          v-if="selectedGroup && selectedStack"
        ></stack-collapse-transition>
      </el-collapse-transition>
    </div>
    <stack-edit ref="stackEdit" />
    <slot-label-dialog ref="slotLabelDialog"></slot-label-dialog>
  </div>
</template>
<script>
// components
import StackEdit from '@/components/stack/StackEdit.vue'
import SlotLabelDialog from '@/components/stack/SlotLabelDialog.vue'
import StackCollapseTransition from '@/components/stack/StackCollapseTransition.vue'
// msg
import PagesMessage from '@/core/message/pages'
// apis
import { queryStackSlots } from '@/api/stack'
// types
import { StackInfoWrapUp } from '@/core/models/stack'
import {
  TypeGround,
  TypeStack,
  TypeDock,
  TypeStage
} from '@/core/models/constant'
import { FormModes } from '@/core/configs/types'
export default {
  name: 'StackPage',
  components: {
    StackEdit,
    SlotLabelDialog,
    StackCollapseTransition
  },
  data() {
    return {
      FormModes,
      stacks: [],
      selectedGroup: '',
      selectedStack: {},
      selectedSlot: null,
      collapseTimeout: null,
      rows: ['R01 - R09', 'R10 - R19', 'R20 - R29', 'R30 - R39', 'R40 - R47'],
      grounds: ['Grounds'],
      selected: '',
      selectedType: TypeStack,
      prefix: '',
      no: 'R01A01A',
      TypeStack,
      loading: false,
      loadingData: false
    }
  },
  computed: {
    stackGroups() {
      const group = {}
      this.stacks.forEach(one => {
        let prefix
        if (one.type === TypeStack) {
          prefix = one.no.slice(0, 3)
        } else if ([TypeGround, TypeDock, TypeStage].includes(one.type)) {
          prefix = one.no
        } else {
          throw new Error('unknown type')
        }
        if (!(prefix in group)) {
          group[prefix] = {
            no: prefix,
            stacks: [one]
          }
        } else {
          group[prefix].stacks.push(one)
        }
      })
      return Object.values(group)
    }
  },
  methods: {
    StackInfoWrapUp,
    openStackEdit(stack) {
      this.$refs.stackEdit.open(stack)
    },
    listStack() {
      this.loading = true
      this.resetSelect()
      this.loadingData = true
      queryStackSlots({ slotFuzzy: this.prefix, size: -1 })
        .then(res => {
          if (res) {
            this.stacks = res.records
            this.loading = false
          }
        })
        .finally(() => {
          this.loadingData = false
        })
    },
    resetSelect() {
      this.selectedGroup = ''
      this.selectedStack = {}
    },
    selectStack(group, stack) {
      if (stack === this.selectedStack) {
        return
      }
      this.resetSelect()
      if (this.collapseTimeout) clearTimeout(this.collapseTimeout)
      this.collapseTimeout = setTimeout(() => {
        this.selectedGroup = group.no
        this.selectedStack = stack
        this.selectedSlot = null
      }, 250)
    },
    select(item) {
      this.resetSelect()
      this.stacks = []
      this.selected = item
      this.selectedType =
        item[0] === 'R'
          ? TypeStack
          : item[0] === 'G'
            ? TypeGround
            : item[0] === 'T'
              ? TypeStage
              : TypeDock
      if (this.selectedType === TypeStack) {
        this.prefix = item.slice(0, 2)
      } else {
        this.prefix = item[0]
      }
      this.listStack()
    }
  },
  mounted() {
    this.select(this.rows[0])
    PagesMessage.on(PagesMessage.eventMap.REFRESH_STACK_LIST, () =>
      this.select(this.rows[0])
    )
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.stack-page {
  .shortcuts {
    gap: 10px;
    flex-wrap: wrap;

    ::v-deep .feature-button {
      height: 60px;

      span {
        font-size: 32px !important;
      }
    }

    .el-button {
      font-family: 'oswald bold', sans-serif;
      font-size: 100px;
      margin-left: 0;
    }

    .selected-row {
      @extend .blue-business-bg;
    }

    .selected-ground {
      @extend .blue-business-bg;
    }
  }

  .list {
    gap: 10px;
    min-height: 300px;

    .stack-sections {
      gap: 20px;
      flex-wrap: wrap;
      margin-bottom: 10px;

      .title {
        background-color: #5f9df7 !important;
        color: white;
        padding: 0;
      }
    }

    .common-card {
      margin: 0 !important;
    }
  }

  .grounds-info {
    gap: 10px;

    .grounds {
      @extend .f-r;

      flex-wrap: wrap;
      gap: 20px;

      .ground {
        background-color: $deep-yellow;
      }
    }
  }
}

.cube {
  margin: 0 !important;
  font-size: 36px;
  width: 80px !important;
  height: 80px !important;
  font-family: 'oswald bold', sans-serif;

  &.selected-cube {
    background-color: $deep-green !important;
  }

  @extend .shadow-level-three, .f-c-c-c, .feature-button, .blue-business-bg;
}

.selected-stack-info {
  padding: 0;
  box-shadow: none;

  ::v-deep .common-card__header {
    display: none;
  }
}

.selected-stack-detail {
  width: 100%;
  gap: 20px;
}

.selected-stack-grids {
  gap: 5px;
  flex-wrap: wrap;

  .slot-name {
    border: 2px solid #409eff;
    background-color: rgba(#409eff, 0.1);
    padding: 10px !important;
    border-radius: 5px;
    width: 100px;
    text-align: center;
    font-size: 18px;
    color: #409eff;
    font-weight: bold;

    &:hover {
      cursor: pointer;
      background-color: rgba(#409eff, 0.3);
    }

    &.selected {
      background-color: #409eff;
      color: white;
    }
  }
}
</style>
